<template name = "dateTemplate" lang="html">
		<div class="row">
			<b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>
			<div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
				<div class="sidebar-header">
					<h5>Search</h5>
					<a href="" id="sidebarMenuClose"><feather type="x" class="svg_overflow"></feather></a>
				</div><!-- df-sidebar-header -->
				<div class="sidebar-body">
					<!-- inputSearchForms -->
					<div v-if="properties.uid">
						<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms " v-if="form.division === 'C'">
							<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
							<div class="form-group">
								<label :for="form.id">{{form.name}} <span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span></label>
								<input type="email" class="form-control" :name="form.id" v-model.lazy="receptionData[form.id]" :id="form.id" :placeholder="form.name">
							</div>
						</ul>
					</div>
					<div v-else>
						<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms " v-if="form.division === 'C' && form.name != 'Department'">
							<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
							<div class="form-group" v-if="form.attr != 'contractno'">
								<label :for="form.id">{{form.name}} <span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span></label>
								<input type="email" class="form-control" :name="form.id" v-model.lazy="receptionData[form.id]" :id="form.id" :placeholder="form.name">
							</div>
							<div class="form-group" v-if="form.attr === 'contractno'">
								<label :for="form.id">{{form.name}} <span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span></label>
								<b-field>
									<b-input type="number"
									min="0"
									max="400000"
								    :name="form.id" v-model.lazy="receptionData[form.id]" :id="form.id" :placeholder="form.name">
									</b-input>
								</b-field>
							</div>
						</ul>
					</div>
					<ul class="sidebar-nav" v-else-if="form.division === 'O'">
						<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
						<div class="form-group">
							<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
							<p class="mg-b-0 text-left" v-if="form.value.length > 0"><span v-for="(form1, i) in form.value" v-if="form1.codeCode == receptionData[form.id]">{{form1.codeName}}</span></p>
							<p class="mg-b-0 text-left" v-else-if="form.name == 'Reception No'">
								<a href='#modal14' @click='sendId(properties.uid)' data-toggle="modal" data-animation="effect-flip-horizontal">{{receptionData[form.id]}}</a>
							</p>
							<p class="mg-b-0 text-left" v-else>
								{{receptionData[form.id]}}
							</p>
						</div>
					</ul>
					<!-- inputCompanyForms -->
					<ul class="sidebar-nav" v-for="(form, i) in inputCompanyForms ">
						<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
						<div class="form-group">
							<label :for="form.id">{{form.name}}<span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span></label>
							<b-field>
								<b-autocomplete
									v-model="companyName"
									:id="form.id"
									ref="companyName"
									:data="filteredDataArray"
									:placeholder="form.name"
									@select="option => selected = option">
									<template slot="empty">No results found</template>
								</b-autocomplete>
							</b-field>
						</div>
					</ul>
					<!-- checkboxSearchForms -->
					<ul class="sidebar-nav" v-for="(form, i) in checkboxSearchForms">
						<div class="form-group">
							<label for="formGroupExampleInput" class=" d-block has-text-weight-semibold">{{form.name}}</label> 
							<div class="ml-2 custom-control custom-radio mb-1" v-for="(form1, i) in form.value">
								<input type="radio" :id="form1.codeCode" :name="form.id" :value="form1.codeCode" v-model="receptionData[form.id]" class="custom-control-input" :checked="form1.codeCode == receptionData[form.id]">
								<label class="custom-control-label" :for="form1.codeCode">{{form1.codeName}}</label>
							</div>
						</div>
					</ul>
					<!-- dateSearchForms -->
					<ul class="sidebar-nav" v-for="(form, i) in dateSearchForms">
						<div class="form-group">
							<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
							<p class="mg-b-0 text-left">{{receptionData[form.id]}}</p>
						</div>
					</ul>
				</div><!-- sidebar-body -->
			</div><!-- sidebar -->
			<div class="content content-components pd-b-0-f">
				<div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
					<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
						<div>
							<nav aria-label="breadcrumb">
								<ol class="breadcrumb breadcrumb-style1 mg-b-10">
									<li class="breadcrumb-item">{{this.mainName}}</li>
									<li class="breadcrumb-item" aria-current="page">{{this.subName}}</li>
									<li class="breadcrumb-item active" aria-current="page">Detail</li>
								</ol>
								<h4 class="mg-b-0 tx-spacing--1">{{this.subName}} Detail</h4>
							</nav>
						</div>

						<div class="card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end">
							<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="confirmData()"><feather type="folder" class="wd-10 mg-r-5 svg_overflow"></feather>Confirm</button>
							<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="createData(true)"><feather type="folder" class="wd-10 mg-r-5 svg_overflow"></feather>Save</button>
							<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-if="properties.uid" v-on:click="deleteData()"><feather type="delete" class="wd-10 mg-r-5 svg_overflow"></feather>delete</button>
							<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="goPage()"><feather type="file" class="wd-10 mg-r-5 svg_overflow"></feather>List</button>
						</div>
					</div>
					<div class="card col-lg-8 col-xl-7 mg-b-20 mg-lg-b-25">
						<div class="d-none d-md-block tx-right-f mg-xs-y-15-f">
							<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 is-pulled-left" data-toggle="modal" data-animation="effect-flip-horizontal" v-on:click="this.checkAll"><feather type="check" class="wd-10 mg-r-5 svg_overflow"></feather>Checked</a>
							<a href="#modal11" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="plus" class="wd-10 mg-r-5 svg_overflow"></feather>Add</a>
							<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal" v-on:click="this.sampleDelColumn"><feather type="minus" class="wd-10 mg-r-5 svg_overflow"></feather>Delete</a>
						</div>
						<hot-table id='sample-table' :settings="sheetSettings" :data="sampleData" class="ht-hot-table" ref="sheet" :afterChange="changeData"></hot-table>
					</div><!-- card -->
				</div>
			</div>
			<div class="modal fade" id="modal11" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel11" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered" role="document">
					<div class="modal-content tx-14">
						<div class="modal-header">
							<h6 class="modal-title" id="exampleModalLabel11">Sample Create</h6>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<p class="mg-b-0">Please enter the number of samples to register.</p>
							<p class="mg-b-0">&nbsp;</p>
							<p class="mg-b-0"><input type="number" min='1' max='100' id='addNum' class="form-control"></p>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary tx-13" data-dismiss="modal">Close</button>
							<button type="button" class="btn btn-primary tx-13" data-dismiss="modal" v-on:click="this.sampleAddColumn">Add</button>
						</div>
					</div>
				</div>
			</div>

				<div class="modal fade" id="modal14" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel14" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered chat-width" role="document">
					<div class="modal-content tx-14 chat-height">
						<div class="modal-header">
						<h6 class="modal-title" id="exampleModalLabel14">Chat</h6>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
						</div>
						<div class="modal-body">
							<Chat></Chat>
						</div>
					</div>
				</div>
			</div><!-- chat modal -->
		</div>
	</template>
	<script>

	import Handsontable from "handsontable";
	import { HotTable } from "@handsontable/vue";
	import "handsontable-key-value";
	import common from "@/views/Common/common.js";
	import mediage from "@/views/Common/mediage/column.js";
	import Chat from "@/views/Common/Chat";
	import { Buefy } from 'buefy';

	// Header의 메뉴 정보 호출을 위한 bus event
	import { bus } from "../../main";

	export default {
		name: "Detail",
		props: ["properties"],
		data() {
			return {
				mainName: "",
				subName: "",
				menuData: [], // header.vue data

				mid: "", // menu list id
				msid: "", // menu sheet id
				uid: "", // sheet id
				ssid: "", // sample list id

				/* Reception input Form */
				receptionHeader: [], // 입력 값 header column
				inputSearchForms: [], // 입력 input form
				dateSearchForms: [], // 입력 date form
				checkboxSearchForms: [], // 입력 radio form
				inputCompanyForms: [], // 입력 company form
				inputUserForms: [], // 입력 user form
				inputFigureForms: [], // 입력 figure form

				/* Reception input Form Value */
				receptionData: [],
				defaultReceptionData: [],

				// 데이터 변경 여부
				isWork: 0,

				/* Sample Form */
				sampleHeader: [], // Sample Header
				sampleData: [], // Sample list data
				defaultSampleData: [], // Pre Sample linst data
				sampleChangeData: [], // Sample list change data
				changeCount: 0,
				boolChange: false, // data change ckeck

				/* company auto text */
				companyName: "",
				companyData: [],
				autoCompanyData: [],
				/* Loading */
				isLoading: false,
				isFullPage: true,

				width: 0,
				height: 0,
			};
        },
       
		beforeDestroy() {
			bus.$off("menu_data");
			window.removeEventListener("scroll", this.onScroll);
		},
		created() {
			bus.$on("menu_data", data => {
				this.menuData = data;
				console.log("menudata")
				console.log(this.menuData)
				this.classifyHeader();
				this.getAutoCompleteData();
			});
			window.addEventListener('resize', this.handleResize);
			this.handleResize();
		},
		destroyed(){
			window.removeEventListener('resize', this.handleResize);
		},
		mounted() {
			window.addEventListener("scroll", this.onScroll);
		},
		methods: {
			handleResize() {
				this.width = window.innerWidth;
				this.height = window.innerHeight;
			},
			/*
			* Load Data Reception Headers
			*/
			async classifyHeader() {
			
			//계약관리 저장 
			this.openLoading();
			let data = common.menuHeader(this.properties.mid, this.menuData, 3);
			this.mainName = data[0];
			this.subName = data[1];
			this.msid = data[2];
			this.receptionHeader = data[3];
			this.inputSearchForms = [];
			this.inputCompanyForms = [];
			this.dateSearchForms = [];
			this.checkboxSearchForms = [];
			for (let i in this.receptionHeader) {
				if (this.receptionHeader[i].columnType == "LIST") {
				if (this.receptionHeader[i].columnAttr == "statecode") {
					if (!common.isNull(this.properties.uid)) {
					this.inputSearchForms.push({name: this.receptionHeader[i].columnName,value: this.receptionHeader[i].code,id: this.receptionHeader[i].columnCode,division: "O", 'attr':this.receptionHeader[i].columnAttr});
					}
				} else {
					this.checkboxSearchForms.push({name: this.receptionHeader[i].columnName,id: this.receptionHeader[i].columnCode,value: this.receptionHeader[i].code,division: this.receptionHeader[i].columnDivision, 'attr':this.receptionHeader[i].columnAttr});
				}
				} else if (this.receptionHeader[i].columnType == "DATE") {
				if (!common.isNull(this.properties.uid)) {
					this.dateSearchForms.push({name: this.receptionHeader[i].columnName,value: "",id: this.receptionHeader[i].columnCode,division: this.receptionHeader[i].columnDivision, 'attr':this.receptionHeader[i].columnAttr});
				}
				} else if (this.receptionHeader[i].columnType == "COUNT") {
				} else if (this.receptionHeader[i].columnType == "PIPELINE") {
				} else if (this.receptionHeader[i].columnType == "FIGURE") {
				} else if (this.receptionHeader[i].columnType == "COMPANY") {
					if (!common.isNull(this.properties.uid))this.inputCompanyForms.push({name: this.receptionHeader[i].columnName,value: "",id: this.receptionHeader[i].columnCode,division: this.receptionHeader[i].columnDivision, 'attr':this.receptionHeader[i].columnAttr});
					else this.inputCompanyForms.push({name: this.receptionHeader[i].columnName,value: "",id: this.receptionHeader[i].columnCode,division: this.receptionHeader[i].columnDivision, 'attr':this.receptionHeader[i].columnAttr});
				} else {
					if (this.receptionHeader[i].columnName != "No") {
						if (!common.isNull(this.properties.uid)) {
						    this.inputSearchForms.push({name: this.receptionHeader[i].columnName,value: "",id: this.receptionHeader[i].columnCode,division: this.receptionHeader[i].columnDivision, 'attr':this.receptionHeader[i].columnAttr});
						} else {
							if (this.receptionHeader[i].columnDivision == "C"){
                                this.inputSearchForms.push({name: this.receptionHeader[i].columnName,value: "",id: this.receptionHeader[i].columnCode,division: this.receptionHeader[i].columnDivision, 'attr':this.receptionHeader[i].columnAttr});
                            }
						}
					}
				}
			}
			this.classifySampleHeader();
			},
			/*
			* Load Data Sample Headers
			*/
			async classifySampleHeader() {
			let data = common.detailSamples(this.menuData);//sample data 출력
			this.ssid = data[0];
			this.sampleHeader = data[1];//
			//console.log("제발 찾자")
			console.log(this.sampleHeader) //해당 메뉴칼럼 넣어준다.
			this.sheetSettings.hiddenColumns.columns = [2]; //2번째 컬럼 숨기기
			this.$refs.sheet.settings.columns = []; //this.$refs 사용시 초기화를 해줘야함
			this.$refs.sheet.settings.colHeaders = [];
			for (let i in this.sampleHeader) {
				if (i < 1) {
					this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat("");
					this.$refs.sheet.settings.columns.push({sampleData: "checkbox",type: "checkbox",width: "20px"});
				}
				this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat(this.sampleHeader[i].columnName);
				if (Number(this.sampleHeader[i].columnSort) < 4) {
					
					if (this.sampleHeader[i].columnName == "No") {
						this.$refs.sheet.settings.columns.push({sampleData: this.sampleHeader[i].columnCode,type: "text",readOnly: true,width: "30px"});
						this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat("id");
						this.$refs.sheet.settings.columns.push({sampleData: "id",type: "text",width: "20px",readOnly: true});
					} else {
						this.$refs.sheet.settings.columns.push({sampleData: this.sampleHeader[i].columnCode,type: "text",readOnly: true});
					}
				} else {
					if (this.sampleHeader[i].columnType === "LIST") {
						var source = [];
						for (let j in this.sampleHeader[i].code) {
							if (j == 0) {
								source.push({id:null, name:''});
							}
							source.push({id: this.sampleHeader[i].code[j].codeCode,name: this.sampleHeader[i].code[j].codeName});
						}
						if (this.sampleHeader[i].columnAttr === "statuscode") {
							this.$refs.sheet.settings.columns.push({sampleData: this.sampleHeader[i].columnCode,type: "key-value",readOnly: true,filter: false,source: source,keyProperty: "id",valueProperty: "name"});
						} else {
							this.$refs.sheet.settings.columns.push({sampleData: this.sampleHeader[i].columnCode,type: "key-value",filter: false,source: source,keyProperty: "id",valueProperty: "name"});
						}
					} else if (this.sampleHeader[i].columnType === "DATE") {
						this.$refs.sheet.settings.columns.push({sampleData: this.sampleHeader[i].columnCode,type: "date",dateFormat: "YYYY-MM-DD"});

					} else this.$refs.sheet.settings.columns.push({sampleData: this.sampleHeader[i].columnCode,type: "text"});
				}
			}
			console.log("sample 데이터에 뭐 있는 지 파악")// 여기서 해당 칼럼을 대입해준다
			console.log(this.sampleHeader)
			console.log(this.$refs.sheet.settings.colHeaders)
			this.classifyData();
			},
			/*
			* Load Data Headers & Samples Data
			*/
			async classifyData() {
			if (!common.isNull(this.properties.uid)) {
				console.log("receptons(1)--------")
				var params = [];
				params = { ssid: this.ssid };
				params["uid"] = this.properties.uid;
				var request = { params: params };
				console.log()
				await this.$axios.get(this.$apiHost + "/receptions/detail", request).then(res => {
					console.log("receptons(1)--------")
					this.receptionData = res.data;
					console.log(this.receptionData)
					for (let i in res.data) this.defaultReceptionData[i] = res.data[i]; // 불필요한 저장을 방지 하기 위하여 처음 불러온 데이터를 배열에 넣어준다 (key:value)
				})
				.catch(err => {
					console.log(err);
				});
				var thisData = [];
				var preData = [];
				for (let i in this.receptionData.samples) {
					this.receptionData.samples[i].No = Number(i) + 1;
					thisData = thisData.concat("false");
					for (let j in this.sampleHeader) {
						if (this.sampleHeader[j].columnName == "No") {
							thisData = thisData.concat(this.receptionData.samples[i].No);
							thisData = thisData.concat(this.receptionData.samples[i].id);
							preData = preData.concat(this.receptionData.samples[i].No);
							preData = preData.concat(this.receptionData.samples[i].id);
						} else {
							thisData = thisData.concat(this.receptionData.samples[i][this.sampleHeader[j].columnCode]);
							preData = preData.concat(this.receptionData.samples[i][this.sampleHeader[j].columnCode]);
						}
					}
					this.sampleData.push(thisData);
					//console.log("칼럼 데이터 데이터 확인")
					//console.log("---")
					//console.log(this.sampleData)
					this.defaultSampleData.push(preData);
					thisData = [];
					preData = [];
                } 
                //2020-11-05 수정 hjh
				if (!common.isNull(this.receptionData[common.find_type_code(this.receptionHeader, "COMPANY")])) this.companyName = this.receptionData[common.find_type_code(this.receptionHeader, "COMPANY")];
			}
			this.rendertab();
			this.isLoading = false;
			},
			/*
			* Sample Add Column
			*/
			async sampleAddColumn() {
				let sampleData = [];
				const colCnt = this.$refs.sheet.hotInstance.countRows();
				const colNum = $("#addNum").val();
				$("#addNum").val("");
				for (let i = Number(colCnt); i < Number(colCnt) + Number(colNum); i++) {
					if (i === 0) {
						this.openLoading();
					}
					this.sampleData.push({ 1: Number(i) + 1 });
					if (i === Number(colCnt) + Number(colNum) - 1) {
						this.isLoading = false;
					}
				}

				// 데이터 변경 여부
				this.isWork++;
				this.rendertab();
				this.isLoading = false;
			},
			/*
			* Sample Delete Column
			*/
			async sampleDelColumn() {
			const colCnt = this.$refs.sheet.hotInstance.countRows();
			for (let i = colCnt - 1; i >= 0; i--) {
				if (this.$refs.sheet.hotInstance.getDataAtCell(i, 0) == true) {
				this.$refs.sheet.hotInstance.alter("remove_row", i, 1);
				}
			}
			for (let i = 0; i < this.$refs.sheet.hotInstance.countRows(); i++) {
				this.$refs.sheet.hotInstance.setDataAtCell(i, 1, i + 1);
			}
			// 데이터 변경 여부
			this.isWork++;
			this.rendertab();
			this.isLoading = false;
			},
			/*
			* Sample Data Change Arrary Insert
			*/
			async changeData(source) {
			if (this.$refs.sheet.hotInstance) {
				this.sampleChangeData = this.$refs.sheet.hotInstance.getData();
			}
			if (arguments[1] === "edit" || arguments[1] === "Autofill.fill") {
				//문제 없음
				// arguments[0][0][3] => 입력값 arguments[0][0][0] => rownum
				// arguments[0][0][2] (이전 데이터) arguments[0][0][3] (변경 데이터)
				if (!common.isNull(arguments[0][0][3])) {
					if (arguments[0][0][3] != arguments[0][0][2]) {
						// 변경된 값이 같은 경우를 대비
						this.boolChange = true;
					}
				}

				if (arguments[0][0][2] && !arguments[0][0][3]) {
					this.boolChange = true;
				}
			} else if (this.isWork > 0) {
				this.boolChange = true;
			}
			},
			/*
			* Reception & Samples Create data
			*/
			async createData(evt) { // 계약번호 추가 모듈
				if (evt) {
					this.openLoading();
				}
				var params = [];
				var sendKey = "";
				var sendValue = "";
				var changeData = [];
				var thisData = [];
				for (let i in this.sampleChangeData) {
					for (let j in this.sampleChangeData[i]) {
						if (j > 2) {
							changeData[this.sampleHeader[Number(j - 2)].columnCode] = this.sampleChangeData[i][j];
						}
					}
					thisData.push($.extend(true, {}, changeData));
					changeData = [];
				}

				params = {
					msid: this.msid,
					uid: this.properties.uid,
					ssid: this.ssid,
					mediAgeFlag: false,
					samples: thisData
				};
			if (!common.isNull(this.companyName))
				this.receptionData[
				common.find_type_code(this.receptionHeader, "COMPANY")
				] = this.companyName;
			for (let i in this.receptionHeader) {
				sendKey = this.receptionHeader[i].columnCode;
				sendValue = this.receptionData[this.receptionHeader[i].columnCode];
				if (
				this.receptionData[this.receptionHeader[i].columnCode] !=
				this.defaultReceptionData[this.receptionHeader[i].columnCode]
				) {
					this.boolChange = true;
				}
				
				if (sendValue) {
					params[sendKey] = sendValue;
				}
            }
            let requiredHeader = common.findRequiredByHeader(this.receptionHeader) //리스트 필수값
            for (let i in requiredHeader) { 
                let check = Object.keys(params).find(item => item == requiredHeader[i].columnCode);
                if (!check) {
                     this.$buefy.dialog.alert({
                        message: 'Please Enter '+requiredHeader[i].columnName,
                        size: 'is-medium',
                        type: 'is-danger'
                    })
                    this.isLoading = false;
                    return false;
                }
            }
        
            if(this.boolChange){
				if (this.companyName === '메디에이지') {
					params.mediAgeFlag = true;
					let require = mediage.requireColumn();
					for (let i in params.samples){
						for (let j in require) {
							if (!params.samples[i][require[j].columnCode]) {
								this.$buefy.dialog.alert({
									message: 'Please Enter '+require[j].columnName,
									size: 'is-medium',
									type: 'is-danger'
								})
								this.isLoading = false;
								return false;
							}
						}
					}
				}
				console.log("data>>>")
				console.log(params)
            	this.$axios.post(this.$apiHost+'/'+this.$route.name.substring(0, this.$route.name.indexOf('_')), params)
            	.then(res=>{
					if (res.data.message !== '') {
						this.$buefy.notification.open({
							duration: 2000,
							message: res.data.message,
							position: 'is-bottom-right',
							type: 'is-success',
							hasIcon: true
						})
					} else {
						this.$buefy.notification.open({
							duration: 2000,
							message: res.data.message,
							position: 'is-bottom-right',
							type: 'is-danger',
							hasIcon: true
						})
					}
                    sessionStorage.setItem('uid',res.data.uid);
                    this.properties.uid = res.data.uid;
                    this.boolChange = false;
                    this.isLoading = false;
                    if (evt) {
                        this.$router.go({name:this.$route.name});
                    } else {
                        this.confirmData();
                    }
            	})
            	.catch(err=>{
            		if(err){
                        this.$buefy.dialog.alert({
                            message: 'The system failed and the save failed. Please contact your system administrator.',
                            size: 'is-medium',
                            type: 'is-danger'
                        })
            		}
            		console.log(err)});

            }else{
            	this.isLoading = false;
                this.$buefy.dialog.alert({
                    message: 'No data has been changed. Can not save.',
                    size: 'is-medium',
                    type: 'is-danger'
                })
            	return false;
            }
        },
		
        /*
        * confirm Data page Move
        */
        async confirmData() {
            if (this.boolChange) {
                this.createData(false);
                return false;
            } 
            if (this.properties.uid) {
                const uid = this.properties.uid;
                const menuSheetId = this.msid;
                this.$buefy.dialog.confirm({
                    message: 'Are you sure you want to confirm?',
                    size: 'is-medium',
                    onConfirm: async () => {
                        this.openLoading();
                        this.$axios.patch(this.$apiHost + "/" + this.$route.name.replace("_detail", "") + "/confirm",
                        {uid, menuSheetId}).then(res => {
							console.log(res.data)
							if (res.data.flag) {
								this.$buefy.notification.open({
									duration: 2000,
									message: res.data.message,
									position: 'is-bottom-right',
									type: 'is-success',
									hasIcon: true
								})
							} else {
								this.$buefy.notification.open({
									duration: 2000,
									message: res.data.message,
									position: 'is-bottom-right',
									type: 'is-danger',
									hasIcon: true
								})
							}
                            sessionStorage.setItem("uid", uid);
                            this.isLoading = false;
                            this.$router.push({
                                name: "receptions_completion",
                                params: { mid: this.properties.mid, uid: uid, type: "detail" }
                            });
                        });
                    },
                    onCancel: () => {
                        this.isLoading = false;
                        return false;
                    }
                });
            } else {
                this.createData(false);
                return false;
            }
        },
        /*
        * delete Data page Move
        */
        async deleteData() {
            this.$buefy.dialog.confirm({
                message: 'Are you sure you want to delete?',
                size: 'is-medium',
                onConfirm: async () => {
                    var receptionNo = "";
                    this.openLoading();
                    for (let i in this.receptionHeader) {
                        if (this.receptionHeader[i].columnAttr === "receptionno") {
                            receptionNo = this.receptionData[this.receptionHeader[i].columnCode];
                            break;
                        }
                    }
                    this.$axios.patch(this.$apiHost + "/" + this.$route.name.substring(0, this.$route.name.indexOf("_")) +
                        "/delete",
                        { param: { receptionNo: receptionNo } }
                    )
                    .then(res => {
                        this.isLoading = false;
                        this.$router.push({
                            name: this.$route.name.replace("_detail", ""),
                            params: { mid: this.properties.mid, type: "list" }
                        });
                    })
                    .catch(err => {
                        if (err) {
                            this.$buefy.dialog.alert({
                                message: 'The system failed and the deleted failed. Please contact your system administrator.',
                                size: 'is-medium',
                                type: 'is-danger'
                            })
                        }
                        console.log(err);
                    });
                },
                onCancel: () => {
                    this.isLoading = false;
                    return false;
                }
            });
        },
        /*
        * List page Move
        */
        goPage() {
            if (this.boolChange) {
                this.$buefy.dialog.confirm({
                    message: 'You have changed data. Would you like to leave??',
                    size: 'is-medium',
                    onConfirm: async () => {
                        this.$router.push({
                        name: this.$route.name.replace("_detail", ""),
                        params: { mid: this.properties.mid, type: "list" }
                    });
                    },
                    onCancel: () => {
                        return false;
                    }
                });
            
            } else {
                this.$router.push({
                    name: this.$route.name.replace("_detail", ""),
                    params: { mid: this.properties.mid, type: "list" }
                });
            }
        },
   
        /*
        * Reception Data Check All
        */
        async checkAll() {
        const colCnt = this.$refs.sheet.hotInstance.countRows();
        var diffCnt = 0;
        for (let i = 0; i < colCnt; i++) {
            if (this.$refs.sheet.hotInstance.getDataAtCell(i, 0) === true) {
            diffCnt = diffCnt + 1;
            }
        }
        for (let i = 0; i < colCnt; i++) {
            if (diffCnt > 0 && diffCnt <= colCnt) {
            this.$refs.sheet.hotInstance.setDataAtCell(i, 0, false);
            } else {
            this.$refs.sheet.hotInstance.setDataAtCell(i, 0, true);
            }
        }
        this.rendertab();
        },
        /*
        * handsontable 문제가 있음 화면에 정상 랜더링이 아니면 화면이 나타나지 않음 그래서 setTimeout으로 2번 실행하여 랜더링 위치 잡는 함수
        */
        rendertab() {
        // height 는 Hansontable이 height를 설정하지 않으면 Handsontable event 가 일어날때마다 계속 height가 무한정 늘어남
        // hotInstance의 updateSettings를 사용하여 기본 setting 값을 수정 한다.
        if (this.sampleData.length > 0) {
			let height = (Number(this.height) - 345)+'px';
				
			// handsontable render 기본 높이 구하기
			// let height = (((this.$refs.sheet.hotInstance.countRows()) * 34)+50+100)+'px';
			// this.$refs.sheet.hotInstance.updateSettings({height:height})
			this.$refs.sheet.hotInstance.updateSettings({height:height})

			const rows = (this.$refs.sheet.hotInstance.countRows() / 10) + 1;
			for(let i = 0; i < rows ;i++){
				setTimeout(() => {this.$refs.sheet.hotInstance.render();}, 10 * 20)
				// this.$refs.sheet.hotInstance.render();
			}
            //let height = this.$refs.sheet.hotInstance.countRows() * 34 + 500 + "px";
            //this.$refs.sheet.hotInstance.updateSettings({ height: height });
            // Handsontable 문제로 화면이 전환될때 기존에 출력 화면 위치를 잃어 버림, render를 한번 사용하면 화면에 출력될 디자인만 그린다
            // 출력 위치까지 잡으려면 render를 한번 더 사용해야한다. 연속으로 render를 하면 되지 않아서 setTimeout으로 약간의 시간차를 두고 render 실행한다
            // 하지만 tab를 사용할 때 데이터가 있다면 4줄정도만 나오게 된다. 이부분 때문에 동일한 render를 무려 8번이나 실행했다.
            // 그렇다고 setTimeout의 시간을 늘려 render 시간을 해주는건 헛수고 이다.
            // 짧은 시간 반복 횟수가 중요 함 (10*20 timeout이 가장 적절하며, 20이하는 render 안됨)
            //setTimeout(() => {
            //this.$refs.sheet.hotInstance.render();
            //}, 10 * 80);
           // this.$refs.sheet.hotInstance.render();
        } 
		//else {
          //  setTimeout(() => {
            //this.$refs.sheet.hotInstance.render();
            //}, 10 * 20);
            //this.$refs.sheet.hotInstance.render();
        //}
        },
        /*
        * Auto Data
        */
        async getAutoCompleteData() {
            await this.$axios.get(this.$apiHost + "/users/auto").then(res => {
                let compN = [];
                let jsonArr = []; //id,name convert에 사용
                res.data.forEach(a => {
                let json = { companyName: a.companyName, companyId: a.companyId };
                compN.push(a.companyName);
                jsonArr.push(json);
                });
                this.companyData = jsonArr;
                this.autoCompanyData = compN; //자동완성 데이터
            });
        },
        /*
        * page Loading bar
        */
        async openLoading() {
            this.isLoading = true;
            setTimeout(() => {
                this.isLoading = false;
            }, 10 * 1000);
        },
        sendId(id){
            bus.$emit("receptid", id);
        },
    },
    components: {
        HotTable,
        Chat
    },
    computed: {
        sheetSettings() {
        let settings = this.$store.getters.sheetSettings;
        return settings;
        },
        filteredDataArray() {
        return this.autoCompanyData.filter(option => {
            return (
            option
                .toString()
                .toLowerCase()
                .indexOf(this.companyName.toLowerCase()) >= 0
            );
        });
        }
    },
    watch: {
        // sampleData:function(){
        // }
    }
    };
    </script>
    <style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>



// WEBPACK FOOTER //
// src/views/Contract/DetailForm.vue